import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import phoneNumberService from '../services/phoneNumberService';
import configService from '../services/configService';

function PhoneNumberSelector({ onComplete }) {
  const { user, updateUserProfile } = useAuth();
  const [selectedNumber, setSelectedNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedAreaCode, setSelectedAreaCode] = useState(null);
  const [availableNumbers, setAvailableNumbers] = useState([]);
  const [loadingNumbers, setLoadingNumbers] = useState(false);
  const [existingAssistantPhone, setExistingAssistantPhone] = useState(null);
  const [checkingExisting, setCheckingExisting] = useState(true);

  const allAreaCodes = [
    // US Area Codes
    { code: '201', location: 'New Jersey', country: 'US' },
    { code: '202', location: 'Washington, DC', country: 'US' },
    { code: '203', location: 'Connecticut', country: 'US' },
    { code: '205', location: 'Alabama', country: 'US' },
    { code: '206', location: 'Seattle, WA', country: 'US' },
    { code: '212', location: 'New York, NY', country: 'US' },
    { code: '213', location: 'Los Angeles, CA', country: 'US' },
    { code: '214', location: 'Dallas, TX', country: 'US' },
    { code: '215', location: 'Philadelphia, PA', country: 'US' },
    { code: '216', location: 'Cleveland, OH', country: 'US' },
    { code: '281', location: 'Houston, TX', country: 'US' },
    { code: '301', location: 'Maryland', country: 'US' },
    { code: '302', location: 'Delaware', country: 'US' },
    { code: '303', location: 'Denver, CO', country: 'US' },
    { code: '305', location: 'Miami, FL', country: 'US' },
    { code: '310', location: 'Los Angeles, CA', country: 'US' },
    { code: '312', location: 'Chicago, IL', country: 'US' },
    { code: '313', location: 'Detroit, MI', country: 'US' },
    { code: '314', location: 'St. Louis, MO', country: 'US' },
    { code: '317', location: 'Indianapolis, IN', country: 'US' },
    { code: '323', location: 'Los Angeles, CA', country: 'US' },
    { code: '347', location: 'New York, NY', country: 'US' },
    { code: '404', location: 'Atlanta, GA', country: 'US' },
    { code: '407', location: 'Orlando, FL', country: 'US' },
    { code: '408', location: 'San Jose, CA', country: 'US' },
    { code: '410', location: 'Baltimore, MD', country: 'US' },
    { code: '412', location: 'Pittsburgh, PA', country: 'US' },
    { code: '415', location: 'San Francisco, CA', country: 'US' },
    { code: '469', location: 'Dallas, TX', country: 'US' },
    { code: '480', location: 'Arizona', country: 'US' },
    { code: '502', location: 'Louisville, KY', country: 'US' },
    { code: '503', location: 'Portland, OR', country: 'US' },
    { code: '504', location: 'New Orleans, LA', country: 'US' },
    { code: '510', location: 'Oakland, CA', country: 'US' },
    { code: '512', location: 'Austin, TX', country: 'US' },
    { code: '513', location: 'Cincinnati, OH', country: 'US' },
    { code: '516', location: 'New York', country: 'US' },
    { code: '602', location: 'Phoenix, AZ', country: 'US' },
    { code: '612', location: 'Minneapolis, MN', country: 'US' },
    { code: '614', location: 'Columbus, OH', country: 'US' },
    { code: '615', location: 'Nashville, TN', country: 'US' },
    { code: '617', location: 'Boston, MA', country: 'US' },
    { code: '619', location: 'San Diego, CA', country: 'US' },
    { code: '646', location: 'New York, NY', country: 'US' },
    { code: '650', location: 'California', country: 'US' },
    { code: '702', location: 'Las Vegas, NV', country: 'US' },
    { code: '703', location: 'Virginia', country: 'US' },
    { code: '704', location: 'Charlotte, NC', country: 'US' },
    { code: '713', location: 'Houston, TX', country: 'US' },
    { code: '714', location: 'California', country: 'US' },
    { code: '716', location: 'Buffalo, NY', country: 'US' },
    { code: '718', location: 'New York, NY', country: 'US' },
    { code: '720', location: 'Denver, CO', country: 'US' },
    { code: '773', location: 'Chicago, IL', country: 'US' },
    { code: '786', location: 'Miami, FL', country: 'US' },
    { code: '801', location: 'Salt Lake City, UT', country: 'US' },
    { code: '813', location: 'Tampa, FL', country: 'US' },
    { code: '816', location: 'Kansas City, MO', country: 'US' },
    { code: '818', location: 'Los Angeles, CA', country: 'US' },
    { code: '832', location: 'Houston, TX', country: 'US' },
    { code: '858', location: 'San Diego, CA', country: 'US' },
    { code: '901', location: 'Memphis, TN', country: 'US' },
    { code: '904', location: 'Jacksonville, FL', country: 'US' },
    { code: '916', location: 'Sacramento, CA', country: 'US' },
    { code: '917', location: 'New York, NY', country: 'US' },
    { code: '919', location: 'Raleigh, NC', country: 'US' },
    { code: '925', location: 'California', country: 'US' },
    { code: '929', location: 'New York, NY', country: 'US' },
    { code: '949', location: 'California', country: 'US' },
    { code: '972', location: 'Dallas, TX', country: 'US' },
    // Canadian Area Codes
    { code: '204', location: 'Manitoba', country: 'CA' },
    { code: '226', location: 'Ontario', country: 'CA' },
    { code: '236', location: 'British Columbia', country: 'CA' },
    { code: '249', location: 'Ontario', country: 'CA' },
    { code: '250', location: 'British Columbia', country: 'CA' },
    { code: '289', location: 'Ontario', country: 'CA' },
    { code: '306', location: 'Saskatchewan', country: 'CA' },
    { code: '343', location: 'Ontario', country: 'CA' },
    { code: '365', location: 'Ontario', country: 'CA' },
    { code: '403', location: 'Alberta', country: 'CA' },
    { code: '416', location: 'Toronto, ON', country: 'CA' },
    { code: '418', location: 'Quebec', country: 'CA' },
    { code: '431', location: 'Manitoba', country: 'CA' },
    { code: '437', location: 'Ontario', country: 'CA' },
    { code: '438', location: 'Quebec', country: 'CA' },
    { code: '450', location: 'Quebec', country: 'CA' },
    { code: '506', location: 'New Brunswick', country: 'CA' },
    { code: '514', location: 'Montreal, QC', country: 'CA' },
    { code: '519', location: 'Ontario', country: 'CA' },
    { code: '548', location: 'Ontario', country: 'CA' },
    { code: '579', location: 'Quebec', country: 'CA' },
    { code: '581', location: 'Quebec', country: 'CA' },
    { code: '587', location: 'Alberta', country: 'CA' },
    { code: '604', location: 'Vancouver, BC', country: 'CA' },
    { code: '613', location: 'Ottawa, ON', country: 'CA' },
    { code: '639', location: 'Saskatchewan', country: 'CA' },
    { code: '647', location: 'Toronto, ON', country: 'CA' },
    { code: '672', location: 'British Columbia', country: 'CA' },
    { code: '705', location: 'Ontario', country: 'CA' },
    { code: '709', location: 'Newfoundland', country: 'CA' },
    { code: '742', location: 'Ontario', country: 'CA' },
    { code: '778', location: 'British Columbia', country: 'CA' },
    { code: '780', location: 'Alberta', country: 'CA' },
    { code: '782', location: 'Nova Scotia', country: 'CA' },
    { code: '807', location: 'Ontario', country: 'CA' },
    { code: '819', location: 'Quebec', country: 'CA' },
    { code: '825', location: 'Alberta', country: 'CA' },
    { code: '867', location: 'Northwest Territories', country: 'CA' },
    { code: '873', location: 'Quebec', country: 'CA' },
    { code: '902', location: 'Nova Scotia', country: 'CA' },
    { code: '905', location: 'Ontario', country: 'CA' }
  ];

  const countries = [
    { code: 'US', name: 'United States' },
    { code: 'CA', name: 'Canada' }
  ];

  const filteredAreaCodes = allAreaCodes.filter(ac => ac.country === selectedCountry);

  const groupedAreaCodes = filteredAreaCodes.reduce((groups, areaCode) => {
    const state = areaCode.location.split(',').pop().trim() || areaCode.location;
    if (!groups[state]) groups[state] = [];
    groups[state].push(areaCode);
    return groups;
  }, {});

  useEffect(() => {
    // Check if assistant phone already exists
    const checkExistingPhone = async () => {
      try {
        const cognitoUserId = user?.attributes?.sub;
        if (!cognitoUserId) {
          setCheckingExisting(false);
          return;
        }
        
        const config = await configService.getBusinessConfigByUserId(cognitoUserId);
        
        // If assistant phone already exists, show it instead of selection
        if (config?.assistant_phone) {
          setExistingAssistantPhone(config.assistant_phone);
          setCheckingExisting(false);
          return;
        }
        
        // No existing assistant phone, proceed with selection setup
        if (config?.phone_number) {
          const businessAreaCode = extractAreaCode(config.phone_number);
          if (businessAreaCode) {
            const matchingAreaCode = allAreaCodes.find(ac => ac.code === businessAreaCode);
            if (matchingAreaCode) {
              setSelectedCountry(matchingAreaCode.country);
              setSelectedAreaCode(businessAreaCode);
              setCheckingExisting(false);
              return;
            }
          }
        }
        
        // Fallback to US if no business phone detected
        setSelectedCountry('US');
        setSelectedAreaCode('415');
      } catch (error) {
        console.warn('Could not load business config:', error);
        setSelectedCountry('US');
        setSelectedAreaCode('415');
      } finally {
        setCheckingExisting(false);
      }
    };
    
    checkExistingPhone();
  }, [user]);

  useEffect(() => {
    // Only load phone numbers when both country and area code are set
    if (selectedAreaCode && selectedCountry) {
      loadPhoneNumbers();
    }
  }, [selectedAreaCode, selectedCountry]);

  const extractAreaCode = (phoneNumber) => {
    if (!phoneNumber) return null;
    const cleaned = phoneNumber.replace(/\D/g, '');
    if (cleaned.length >= 10) {
      return cleaned.substring(cleaned.length === 11 ? 1 : 0, cleaned.length === 11 ? 4 : 3);
    }
    return null;
  };

  const loadPhoneNumbers = async () => {
    console.log(`Loading phone numbers for area code: ${selectedAreaCode}, country: ${selectedCountry}`);
    setLoadingNumbers(true);
    try {
      const response = await phoneNumberService.getAvailablePhoneNumbers({
        areaCode: selectedAreaCode,
        country: selectedCountry,
        limit: 3
      });
      console.log('Phone numbers response:', response);
      const phoneNumbers = response.phone_numbers || response.numbers || [];
      console.log('Extracted phone numbers:', phoneNumbers);
      setAvailableNumbers(phoneNumbers);
    } catch (error) {
      console.error('Error loading phone numbers:', error);
      // Fallback to mock data if API fails
      const mockNumbers = [
        { number: `(${selectedAreaCode}) 123-4567`, location: getLocationForAreaCode(selectedAreaCode), price: '$15/mo' },
        { number: `(${selectedAreaCode}) 234-5678`, location: getLocationForAreaCode(selectedAreaCode), price: '$15/mo' },
        { number: `(${selectedAreaCode}) 345-6789`, location: getLocationForAreaCode(selectedAreaCode), price: '$15/mo' }
      ];
      console.log('Using mock numbers:', mockNumbers);
      setAvailableNumbers(mockNumbers);
    } finally {
      setLoadingNumbers(false);
    }
  };

  const getLocationForAreaCode = (areaCode) => {
    const found = allAreaCodes.find(ac => ac.code === areaCode);
    return found ? found.location : 'Unknown';
  };

  const handleCountryChange = (e) => {
    const newCountry = e.target.value;
    setSelectedCountry(newCountry);
    const firstAreaCode = allAreaCodes.find(ac => ac.country === newCountry);
    if (firstAreaCode) {
      setSelectedAreaCode(firstAreaCode.code);
    }
  };

  const handleAreaCodeChange = (e) => {
    setSelectedAreaCode(e.target.value);
  };

  const handleSelect = async (number) => {
    setLoading(true);
    
    try {
      // Save assistant phone using business_id approach
      console.log('📞 PHONE SELECTION: Saving assistant phone:', number);
      const saveResult = await configService.saveAssistantPhone(number);
      console.log('📞 PHONE SELECTION: Assistant phone saved successfully:', saveResult);
      
      setSelectedNumber(number);
      setExistingAssistantPhone(number);
      
      // Trigger Dashboard to reload configuration status
      console.log('📞 PHONE SELECTION: Triggering step completion');
      onComplete();
    } catch (error) {
      console.error('📞 PHONE SELECTION: Error saving phone number:', error);
    } finally {
      setLoading(false);
    }
  };

  // Show loading while checking for existing phone
  if (checkingExisting) {
    return (
      <div style={{
        background: 'white',
        padding: '1rem',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
        width: '100%',
        textAlign: 'center'
      }}>
        <div style={{
          width: '32px',
          height: '32px',
          border: '3px solid #f3f4f6',
          borderTop: '3px solid #2563eb',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 1rem'
        }}></div>
        <p>Checking your phone number...</p>
      </div>
    );
  }

  // Show existing phone number if one exists
  if (existingAssistantPhone) {
    return (
      <div style={{
        background: 'white',
        padding: '1rem',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
        width: '100%',
        textAlign: 'center'
      }}>
        <h3 style={{ marginBottom: '1.5rem', color: '#10b981' }}>Your Assistant's Phone Number</h3>
        <div style={{
          background: '#f0fdf4',
          border: '2px solid #10b981',
          borderRadius: '12px',
          padding: '2rem',
          marginBottom: '1.5rem'
        }}>
          <div style={{
            fontSize: '2rem',
            fontWeight: 'bold',
            color: '#10b981',
            marginBottom: '0.5rem',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            maxWidth: '100%'
          }}>
            {existingAssistantPhone}
          </div>
          <p style={{ color: '#059669', margin: 0 }}>
            ✓ Phone number configured
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      background: 'white',
      padding: '1rem',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
      width: '100%'
    }}>
      <h3 style={{ marginBottom: '1.5rem', textAlign: 'center' }}>Choose Your Assistant's Phone Number</h3>
      
      {/* Country Selector */}
      <div style={{ marginBottom: '1rem' }}>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#374151' }}>
          Select Country:
        </label>
        <select
          value={selectedCountry}
          onChange={handleCountryChange}
          style={{
            width: '100%',
            padding: '0.75rem',
            border: '2px solid #e5e7eb',
            borderRadius: '8px',
            fontSize: '1rem',
            background: 'white',
            cursor: 'pointer'
          }}
        >
          {countries.map((country) => (
            <option key={country.code} value={country.code}>
              {country.name}
            </option>
          ))}
        </select>
      </div>

      {/* Area Code Selector */}
      <div style={{ marginBottom: '1.5rem' }}>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#374151' }}>
          Select Area Code:
        </label>
        <select
          value={selectedAreaCode}
          onChange={handleAreaCodeChange}
          style={{
            width: '100%',
            padding: '0.75rem',
            border: '2px solid #e5e7eb',
            borderRadius: '8px',
            fontSize: '1rem',
            background: 'white',
            cursor: 'pointer'
          }}
        >
          {Object.keys(groupedAreaCodes).sort().map((state) => (
            <optgroup key={state} label={state}>
              {groupedAreaCodes[state].map((areaCode) => (
                <option key={areaCode.code} value={areaCode.code}>
                  ({areaCode.code}) {areaCode.location}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>

      {/* Phone Numbers List */}
      {loadingNumbers ? (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>
          <div style={{
            width: '32px',
            height: '32px',
            border: '3px solid #f3f4f6',
            borderTop: '3px solid #2563eb',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }}></div>
          Loading phone numbers...
        </div>
      ) : availableNumbers.length > 0 ? (
        <div style={{ display: 'grid', gap: '1rem' }}>
          {availableNumbers.map((item, index) => {
            const phoneNumber = item.phone_number || item.number;
            const location = item.friendly_name || getLocationForAreaCode(selectedAreaCode);
            const price = item.price || '$15/mo';
            const isLastAvailable = availableNumbers.length === 1;
            
            return (
              <div
                key={index}
                style={{
                  border: isLastAvailable ? '2px solid #f59e0b' : '2px solid #e5e7eb',
                  borderRadius: '8px',
                  padding: '1rem',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  backgroundColor: 'white',
                  position: 'relative'
                }}
                onClick={() => handleSelect(phoneNumber)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#2563eb';
                  e.currentTarget.style.backgroundColor = '#f8fafc';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#e5e7eb';
                  e.currentTarget.style.backgroundColor = 'white';
                }}
              >
                {isLastAvailable && (
                  <div style={{
                    position: 'absolute',
                    top: '-8px',
                    right: '12px',
                    background: '#f59e0b',
                    color: 'white',
                    padding: '2px 8px',
                    borderRadius: '12px',
                    fontSize: '0.75rem',
                    fontWeight: '500'
                  }}>
                    Last Available
                  </div>
                )}
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#2563eb', marginBottom: '0.5rem' }}>
                    {location}
                  </div>
                  <div style={{ color: '#64748b', fontSize: '1.1rem', fontWeight: '500' }}>
                    {phoneNumber}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '2rem', color: '#64748b' }}>
          <p>No phone numbers available for area code {selectedAreaCode}</p>
          <p style={{ fontSize: '0.9rem', marginTop: '0.5rem' }}>Try selecting a different area code</p>
        </div>
      )}
      
      {loading && (
        <div style={{ textAlign: 'center', marginTop: '1rem', color: '#64748b' }}>
          Setting up your number...
        </div>
      )}
      
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default PhoneNumberSelector;